export default __webpack_public_path__ + "static/media/5.e32d0b76.jpeg";